import script from "./PartnerUserOnboarding.vue?vue&type=script&lang=ts&setup=true"
export * from "./PartnerUserOnboarding.vue?vue&type=script&lang=ts&setup=true"

import "./PartnerUserOnboarding.vue?vue&type=style&index=0&id=24b264bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b264bc"]])

export default __exports__